import { createSelector } from 'reselect';
import { every, find, get, toPairs } from 'lodash';
import { PERMITTED_PERMISSIONS } from 'modules/common/constants/permisssionsTypes';
import * as permissionResources from 'modules/common/constants/appointmentPermissionResources';


const getAppointmentFromProps = () => createSelector(
  (_, props) => props.permissions,
  (_, props) => props.service,
  (permissions, service) => ({
    permissions,
    service,
  }),
);


export const appointmentHavePermission = (appointment, neededPermissions, neededServiceConfig) => {
  const [resourceCode, properties] = toPairs(neededPermissions)[0];
  const roleResources = get(appointment, 'permissions.roleResources', []);
  const resource = find(roleResources, { resourceCode });
  const serviceHasPermission = neededServiceConfig ? get(appointment, neededServiceConfig, false) : true;

  return serviceHasPermission && every(properties, property => PERMITTED_PERMISSIONS.includes(get(resource, property)));
};

// READ PERMISSIONS
export const makeAppointmentReadPermissions = appointment => ({
  canSeeProvider: appointmentHavePermission(appointment, { [permissionResources.APPOINTMENTS_PROVIDER]: ['read'] }),
  canSeeCustomer: appointmentHavePermission(appointment, { [permissionResources.APPOINTMENTS_CUSTOMER]: ['read'] }),
  canSeeSubjects: appointmentHavePermission(appointment, { [permissionResources.APPOINTMENTS_SUBJECTS]: ['read'] }),
  canSeeSchedule: appointmentHavePermission(appointment, { [permissionResources.APPOINTMENTS_SCHEDULE]: ['read'] }),
  canSeeStatus: appointmentHavePermission(appointment, { [permissionResources.APPOINTMENTS_STATUS]: ['read'] }),
  canSeeConversation: appointmentHavePermission(appointment, { [permissionResources.APPOINTMENTS_CONVERSATION]: ['read'] }),
  canSeeSummary: appointmentHavePermission(appointment, { [permissionResources.APPOINTMENTS_SUMMARY]: ['read'] }),
  canSeePrescriptions: appointmentHavePermission(appointment, { [permissionResources.APPOINTMENTS_PRESCRIPTIONS]: ['read'] }),
  canSeeFiles: appointmentHavePermission(appointment, { [permissionResources.APPOINTMENTS_FILES]: ['read'] }),
  canSeeCaseSummary: appointmentHavePermission(appointment, { [permissionResources.APPOINTMENTS_CASE_SUMMARY]: ['read'] }),
});

// UPDATE PERMISSIONS
export const makeAppointmentUpdatePermissions = appointment => ({
  canEditProvider: appointmentHavePermission(appointment, { [permissionResources.APPOINTMENTS_PROVIDER]: ['update'] }),
  canEditCustomer: appointmentHavePermission(appointment, { [permissionResources.APPOINTMENTS_CUSTOMER]: ['update'] }),
  canEditSubjects: appointmentHavePermission(appointment, { [permissionResources.APPOINTMENTS_SUBJECTS]: ['update'] }),
  canEditSchedule: appointmentHavePermission(appointment, { [permissionResources.APPOINTMENTS_SCHEDULE]: ['update'] }),
  canEditStatus: appointmentHavePermission(appointment, { [permissionResources.APPOINTMENTS_STATUS]: ['update'] }),
  canEditSummary: appointmentHavePermission(appointment, { [permissionResources.APPOINTMENTS_SUMMARY]: ['update'] }),
  canEditPrescriptions: appointmentHavePermission(appointment, { [permissionResources.APPOINTMENTS_PRESCRIPTIONS]: ['update'] }),
  canEditFiles: appointmentHavePermission(appointment, { [permissionResources.APPOINTMENTS_FILES]: ['update'] }),
  canEditCaseSummary: appointmentHavePermission(appointment, { [permissionResources.APPOINTMENTS_CASE_SUMMARY]: ['update'] }),
});

export const makeGetReadAppointmentFromPropsPermissions = () => createSelector(
  getAppointmentFromProps(),
  makeAppointmentReadPermissions,
);
